module.exports = __webpack_public_path__ + "src/assets/img/cpzx_icon5@2x.fc2f4256.png";